import React from 'react';
import './GoldJewellery.css';

function GoldJewellery() {
  return (
    <div className="gold-jewellery-page">
      {/* Hero Section */}
      <section className="jewellery-hero">
        <div className="hero-background">
          <div className="hero-overlay">
            <div className="hero-content">
              <h1 className="hero-title">Gold Jewellery</h1>
              <p className="hero-subtitle">Timeless Elegance in Every Piece</p>
            </div>
          </div>
        </div>
      </section>

      {/* Collection Section */}
      <section className="collection-section">
        <div className="container">
          <h2 className="section-title">Our Gold Collections</h2>
          <div className="jewellery-grid">
            <div className="jewellery-card">
              <div className="jewellery-image">
                <div className="placeholder-image">18K Gold</div>
              </div>
              <h3>18K Gold Collection</h3>
              <p>Beautiful 18K gold pieces with 75% pure gold content</p>
            </div>
            <div className="jewellery-card">
              <div className="jewellery-image">
                <div className="placeholder-image">21K Gold</div>
              </div>
              <h3>21K Gold Collection</h3>
              <p>Premium 21K gold jewelry with 87.5% pure gold content</p>
            </div>
            <div className="jewellery-card">
              <div className="jewellery-image">
                <div className="placeholder-image">22K Gold</div>
              </div>
              <h3>22K Gold Collection</h3>
              <p>Luxurious 22K gold pieces with 91.6% pure gold content</p>
            </div>
            <div className="jewellery-card">
              <div className="jewellery-image">
                <div className="placeholder-image">24K Gold</div>
              </div>
              <h3>24K Gold Collection</h3>
              <p>Pure 24K gold jewelry with 99.9% pure gold content</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default GoldJewellery;
